import Vue from 'vue'
import VueRouter from 'vue-router'
import LandingPage from '@/views/LandingPage.vue'
import LoginPage from '@/views/LoginPage.vue'
import HomePage from '@/views/HomePage.vue'
import DashboardPage from '@/views/HomePages/DashboardPage.vue'
import HospitalPage from '@/views/HomePages/HospitalPage.vue'
import Hospitals from '@/views/HomePages/HospitalPages/Hospitals.vue'
import Hospital from '@/views/HomePages/HospitalPages/Hospital.vue'
import PackagePage from '@/views/HomePages/PackagePage.vue'
import UsersPage from '@/views/HomePages/UsersPage.vue'
import AnnouncePage from '@/views/HomePages/AnnouncePage.vue'
import SettingPage from '@/views/HomePages/SettingPage.vue'
import PermissionPage from '@/views/HomePages/SettingPages/PermissionPage.vue'
import MenuPage from '@/views/HomePages/SettingPages/MenuPage.vue'
import PreferencePage from '@/views/HomePages/SettingPages/PreferencePage.vue'
import ServicePages from '@/views/HomePages/SettingPages/ServicePages.vue'
import ApiPage from '@/views/HomePages/ApiPage.vue'
import ProfilePage from '@/views/HomePages/ProfilePage.vue'
import ResetPasswordOnEmail from '@/views/ResetPasswordOnEmail.vue'
import NotificationPage from '../views/HomePages/NotificationPage.vue'
import TaskPage from '../views/HomePages/TaskPage.vue'

import Authentication from '@/views/integrations.vue'
Vue.use(VueRouter)

const routes = [
  { path: '*', redirect: { name: 'landingPage' } },
  {
    path: '/overview',
    name: 'landingPage',
    meta: { requiresLogin: false },
    component: LandingPage
  },
  {
    path: '/login/:provider',
    name: 'loginPage',
    meta: { requiresLogin: false },
    component: LoginPage
  },
  {
    path: '/password/new',
    name: 'ResetPasswordOnEmail',
    meta: { requiresLogin: false },
    component: ResetPasswordOnEmail
  },
  {
    path: '/home',
    name: 'homePage',
    meta: { requiresLogin: true },
    component: HomePage,
    children: [
      {
        path: 'dashboard',
        name: 'dashboardPage',
        meta: { requiresLogin: true },
        component: DashboardPage
      },

      {
        path: 'hospital',
        name: 'hospitalPage',
        redirect: { name: 'hospitalList' },
        meta: { requiresLogin: true },
        component: HospitalPage,
        children: [
          {
            path: '',
            name: 'hospitalList',
            meta: { requiresLogin: true },
            component: Hospitals
          },
          {
            path: ':hospital_id',
            name: 'hospitalDashboard',
            meta: { requiresLogin: true },
            component: Hospital
          }
        ]
      },
      {
        path: 'package',
        name: 'packagePage',
        meta: { requiresLogin: true },
        component: PackagePage
      },
      {
        path: 'users',
        name: 'userPage',
        meta: { requiresLogin: true },
        component: UsersPage
      },
      {
        path: 'announce',
        name: 'announcePage',
        meta: { requiresLogin: true },
        component: AnnouncePage
      },
      {
        path: 'apis',
        name: 'apiPage',
        meta: { requiresLogin: true },
        component: ApiPage
      },

      {
        path: 'profile',
        name: 'profilePage',
        meta: { requiresLogin: true },
        component: ProfilePage
      },
      {
        path: 'profile/:provider',
        meta: { requiresLogin: true },
        component: ProfilePage
      },
      {
        path: 'notification',
        name: 'notificationPage',
        meta: { requiresLogin: true },
        component: NotificationPage
      },

      {
        path: 'task',
        name: 'taskPage',
        meta: { requiresLogin: true },
        component: TaskPage
      },
      {
        path: 'setting',
        name: 'settingPage',
        meta: { requiresLogin: true },
        component: SettingPage,
        children: [
          {
            path: 'permissions',
            name: 'permissionPage',
            meta: { requiresLogin: true },
            component: PermissionPage
          },
          {
            path: 'menus',
            name: 'menuPage',
            meta: { requiresLogin: true },
            component: MenuPage
          },
          {
            path: 'preference',
            name: 'preferencePage',
            meta: { requiresLogin: true },
            component: PreferencePage
          },
          {
            path: 'services',
            name: 'servicePages',
            meta: { requiresLogin: true },
            component: ServicePages
          }
        ]
      }
    ]
  },
  {
    path: '/integration',
    name: 'integration',
    meta: { requiresLogin: false },
    component: Authentication
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: '/app',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

const DEFAULT_TITLE = '1LS Systems'
router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE
  })
})

// # UPDATE 2021-10-31
router.beforeEach((to, from, next) => {
  const ls = localStorage.getItem('Accesstoken')
  if (to.matched.some((x) => x.meta.requiresLogin)) {
    if (ls === undefined || ls === null) {
      // # เป็นหน้าที่ต้อง Authen และไม่มี Authen
      next({ name: 'loginPage' })
    } else {
      // # เป็นหน้าที่ต้อง Authen และมี Authen
      next()
    }
  } else {
    if (ls === undefined || ls === null) {
      // # เป็นหน้าที่ไม่ต้องต้อง Authen และไม่มี Authen
      next()
    } else {
      // # เป็นหน้าที่ไม่ต้อง Authen และมี Authen และไม่ใช่ login
      if (to.name === 'loginPage') next({ name: 'hospitalList' })
      else next()
    }
  }
})

export default router
